export class LeadDto {
  companyName: string;
  name: string;
  phoneNumber: string;
  email: string;
  notes: string;
}
